import { intlFormat } from "date-fns";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { OrderDetails } from "../../../stores/slices/cartSlice";
import { KeyValue } from "../../../ui/KeyValue/KeyValue";
import { PriceDisplay } from "../../../ui/PriceDisplay/PriceDisplay";

export const CartPrintTotal: FunctionComponent<{
  orderDetails: OrderDetails;
}> = ({ orderDetails }) => {
  const { t } = useTranslation();
  const [language] = useLanguage();

  const orderLastUpdatedTimestamp = new Date(
    orderDetails.orderLastUpdatedTimestamp
  );

  return (
    <section className="border border-edge p-1 rounded-section grid grid-cols-3">
      <div className="col-span-2 p-3">
        <h3 className="text-lg">
          <span className="font-medium">
            {t("cart.reference")} #{orderDetails?.orderId}
          </span>{" "}
          <span className="font-thin text-ink-2">
            &ndash;{" "}
            {intlFormat(
              orderLastUpdatedTimestamp,
              {
                day: "numeric",
                month: "short",
                weekday: "short",
                year: "numeric",
              },
              {
                locale: language === "fr" ? "fr-CA" : undefined,
              }
            )}{" "}
            &ndash;{" "}
            {intlFormat(
              orderLastUpdatedTimestamp,
              {
                hour: "numeric",
                minute: "numeric",
              },
              {
                locale: language === "fr" ? "fr-CA" : undefined,
              }
            )}
          </span>
        </h3>
      </div>
      <div className="border border-edge rounded-tw-lg px-3 py-1 divide-y divide-edge">
        <KeyValue className="justify-between py-2">
          <>{t("cart.subtotal")}:</>
          <PriceDisplay>{orderDetails?.orderSubtotal}</PriceDisplay>
        </KeyValue>
        <KeyValue className="justify-between py-2">
          <>
            {t("cart.tax")}({Number(orderDetails?.orderTaxPercent)}
            %):
          </>
          <PriceDisplay>{orderDetails?.orderTaxTotal}</PriceDisplay>
        </KeyValue>
        <KeyValue className="justify-between py-2">
          <>{t("cart.total")}:</>
          <PriceDisplay>{orderDetails?.orderGrandTotal}</PriceDisplay>
        </KeyValue>
      </div>
    </section>
  );
};
